import React, { useState, useEffect, useRef } from "react";
import ApiClient from "../services/api-client"
import { useTranslation } from 'react-i18next';
import CompanyDeductionsGrid from '../components/aggrids/editable-aggrids/company-deductions-grid';
import { useForm } from "react-hook-form";
import { CustomConfirmAlert as confirmAlert } from '../components/custom-confirm-alert';
import { toast } from 'react-toastify';
import useStore from "../hooks/useStore";
import BlockUi from '@availity/block-ui';
import { Loader } from 'react-loaders';


export default function CompanyDeduction() {

    const { t } = useTranslation();
    const deductionsGridRef = useRef();
    const [blockuiLoading, setBlockuiLoading] = useState(false);

    const { handleSubmit } = useForm();

    const onSubmit = () => {
        var deductions = deductionsGridRef.current.getData();
        var company = useStore.getState().selectedCompany;
        var _deductions = deductions.map(e => ({ ...e, company: { id: company.id } }));

        confirmAlert({
            title: t("submitConfirm"),
            message: t("areYouSure"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        setBlockuiLoading(true);
                        ApiClient.saveDeductions(company.id, _deductions).then(
                            () => {
                                toast.success(t("saveSucceded"));
                                setBlockuiLoading(false);
                            },
                            error => {
                                toast.error(error.message + ": " + error.response.data.message);
                                setBlockuiLoading(false);
                            }
                        );
                    }
                },
                { label: t('No') }
            ]
        });
    }

    useEffect(() => {
        const companyId = useStore.getState().selectedCompany.id;
        ApiClient.getCompanyDeductions(companyId).then(
            response => deductionsGridRef.current.setData(response.data),
            error => console.error(error.message || error.toString())
        );
    }, []);


    return (
        <BlockUi tag="div" blocking={blockuiLoading} loader={<Loader active type="ball-beat" />}>
            <div className="container deduction-page">
                <form onSubmit={handleSubmit(onSubmit)}>

                    <header className="deduction-page-header">
                        <div className="d-flex align-items-center gap-2">
                            <div className="deduction-page-icon">
                                <i className="fa fa-scissors"></i>
                            </div>
                            <div>
                                <h5 className="skin mb-0">{t("Deductions")}</h5>
                                <p className="deduction-page-subtitle mb-0">{t("DeductionsInfo")}</p>
                            </div>
                        </div>
                    </header>

                    <div className="deduction-page-body">
                        <CompanyDeductionsGrid ref={deductionsGridRef} />
                    </div>

                    <div className="deduction-page-footer">
                        <button type="submit" className="btn btn-skin">
                            <i className="fa fa-save" style={{ marginRight: 7 }}></i>
                            {t("Save")}
                        </button>
                    </div>

                </form>
            </div>
        </BlockUi>
    );
}
